import {
    Backdrop,
    Grid,
    IconButton,
    Typography
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

  import VisibilityIcon from '@mui/icons-material/Visibility';
import { Helmet } from "react-helmet-async";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";
import SingleMember from "./singleMember";
  
  const MemberReports = () => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [data, setData] = useState([]);
    const [cust, setCust] = useState(null);
    const [open, setOpen] = useState(false);
    const [monthData, setMonthData] = useState([]); //month api
    const [name, setName] = useState(''); //date api
    const [productData, setProductData] = useState([])
    const [activeStep, setActiveStep] = useState("0");
    const [search, setSearch] = useState('')
    const pageOptionMember = [10, 25, 50, 100];
    const [pageMember, setPageMember] = useState(0);
    const [rowsPerPageMember, setRowsPerPageMember] = useState(pageOptionMember[0]);
    const [pageCountMember, setPageCountMember] = useState(0);

    const [dateLimit, setDateLimit] = useState({
      fromDate: moment().subtract(1 , 'years').format("YYYY"),
      toDate: moment().format("YYYY"),
    });
    const onEdit = (e) => {
      console.log(e.row);
      getMonthData(e.row.mobile);
      setName(e.row.partyName)
      setOpen(true);
    };
  
    function getMonthData(number ,) {
    //   console.log(number);
      axios
        .get(`/v1/reports/outlet_member/outlet_sales_mst/${rowsPerPageMember}/${pageMember + 1}/${number}`)
        .then((res) => {
          console.log(res.data.meta.pagination.total);
          setMonthData(res.data.data);
          setPageCountMember(res.data.meta.pagination.total)
        //   setPageMember(res.data.meta.pagination.total)
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
          setMonthData([])
        });
    }
  
    const columns = [
      {
        field: "sno",
        headerName: "S.no",
        minWidth: 70,
        maxWidth: 100,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "date",
        headerName: "Date",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "partyName",
        headerName: "Party Name",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
     
      {
        field: "mobile",
        headerName: "Mobile",
        flex: 1,
        headerAlign: "center",
        align: "center",
        sortable: false,
      },
      {
        field: "balancePoints",
        headerName: "Balance Points",
        flex: 1,
        headerAlign: "center",
        align: "right",
        sortable: false,
        renderCell: (params) => (
          <strong>{params.value}</strong>
        ),
      },
      {
        field: "view",
        headerName: "View",
        flex: 1,
        disableExport: true ,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (params) => {
          return (
            <IconButton size="small" onClick={() => onEdit(params)}>
              <VisibilityIcon />
            </IconButton>
          );
        },
      },
    ];
  
    const rows = _.map(data, (val, idx) => ({
      id: idx,
      sno: idx + 1,
      date: moment(val.created_at).format('DD-MM-YYYY'),
      partyName: val.party_name || '-',
      mobile: val.mobile ,
      balancePoints: val.balance_points || '-',
    }));
    
    const props = {
      columns: columns,
      rows: rows,
      page: page,
      search : search,
      setSearch : setSearch,
      setPage: setPage,
      rowsPerPage: rowsPerPage,
      setRowsPerPage: setRowsPerPage,
      pageCount: pageCount,
      pageOption: pageOption,
    };
   
    // function handleChange(e, name) {
    //   setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format("YYYY") }));
    // }
  
    function handleGetData() {
      axios
        .get(
          `/v1/reports/outlet_member/${rowsPerPage}/${page + 1}/${search}`
        )
        .then((res) => {
          setData(res.data.data);
          console.log(res.data.data.length);
          setPageCount(res.data.meta.pagination.total)
        })
        .catch((err) => {
          dispatch(
            setSnackbar(true, "error", err.response.data.errors[0].message)
          );
        });
    }
    useEffect(() => {
    //   if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
        handleGetData();
    //   }
    }, [rowsPerPage, page, search]);
    console.log(productData);
    return (
      <Fragment>
        <Helmet><title>Member Reports</title></Helmet>
        <Typography variant="h6">Member Reports</Typography>
        {/* <Grid container spacing={2} className="p-2 pt-2">
          <Grid item md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                views={["year"]}
                openTo="year"
                onChange={(e) => handleChange(e, "fromDate")}
                value={dayjs(dateLimit.fromDate)}
                slotProps={{
                  textField: {
                    size: "small",
                    label: "From",
                    style: { width: "100%" },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                views={["year"]}
                openTo="year"
                onChange={(e) => handleChange(e, "toDate")}
                value={dayjs(dateLimit.toDate)}
                slotProps={{
                  textField: {
                    size: "small",
                    label: "To",
                    style: { width: "100%" },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid> */}
        {/* <CustomTable props={props} /> */}
        <CustomDataGrid props={props}/>
      {open &&   <Backdrop open={open} sx={{ zIndex: 1100 }}>
          <Grid
            sx={{
              width: "80%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            {activeStep === "0" ? (
              <SingleMember
                setOpen={setOpen}
                monthData={monthData}
                setActiveStep={setActiveStep}
                name={name}
                setName={setName}
                setPageCountMember={setPageCountMember}
                pageCountMember={pageCountMember}
                rowsPerPageMember={rowsPerPageMember}
                setRowsPerPageMember={setRowsPerPageMember}
                pageMember={pageMember}
                setPageMember={setPageMember}
                pageOptionMember={pageOptionMember}
              />
            ) : null}
          </Grid>
        </Backdrop>}
      </Fragment>
    );
  };
  
  export default memo(MemberReports);
  